import { GET_DMX_OCCUPANCY, GET_DMX_OCCUPANCY_SUCCESS, GET_DMX_OCCUPANCY_ERROR } from './actionTypes';

const initialState = {
  errorGetDmxOccupancy: '',
  loadingGetDmxOccupancy: false,
  occupancyDevices: null,
};

const getOccupancy = (state = initialState, action) => {
  switch (action.type) {
    case GET_DMX_OCCUPANCY:
      state = { ...state, loadingGetDmxOccupancy: true };
      break;
    case GET_DMX_OCCUPANCY_SUCCESS:
      state = { ...state, loadingGetDmxOccupancy: false, occupancyDevices: action.payload.devices };
      break;
    case GET_DMX_OCCUPANCY_ERROR:
      state = { ...state, errorGetDmxOccupancy: action.payload, loadingGetDmxOccupancy: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getOccupancy;
